import { Button, Modal, NumberInput } from "components"

type ModalExportApprovalOpeningStockProps = {
  show: boolean
  onHide: () => void
  maxAmount: number
  amount: number
  label: string
  setAmount: (amount: number) => void
  onButtonExportClick: () => void
}

export const ModalExportApprovalOpeningStock = (props: ModalExportApprovalOpeningStockProps) => {

  return (
    <Modal 
      isOpen={props?.show} 
      size="md" 
      closeModal={props?.onHide} 
      title="Export Data"
      style={{ maxWidth: 600, borderRadius: 10 }}
    >
      <Modal.Body style={{ minHeight: 260, maxHeight: "none", height: "auto" }}> 
        <div className="flex flex-col items-center justify-center min-h-[220px] space-y-6">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-zinc-800">{props?.label}</h2>
            <p className="text-sm text-zinc-500 mt-2">
              Specify how many data entries you want to export
            </p>
          </div>

          <div className="flex items-center space-x-3">
            <button
              className="w-10 h-10 rounded-full bg-zinc-100 hover:bg-zinc-200 text-zinc-600 text-lg font-bold shadow"
              onClick={() => props?.setAmount(props?.amount > 1 ? props?.amount - 1 : 1)}
            >
              −
            </button>

            <NumberInput
              decimalScale={0}
              inputClass="w-[220px]"
              min={1}
              max={props?.maxAmount}
              value={props?.amount}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue === undefined || floatValue <= (props?.maxAmount ?? Infinity);
              }}
              onValueChange={(e) => {
                if (e.floatValue === undefined) {
                  props?.setAmount(undefined as any);
                } else {
                  props?.setAmount(e.floatValue);
                }
              }}
              onBlur={() => {
                if (!props?.amount || props?.amount < 1) {
                  props?.setAmount(1);
                }
              }}
            />

            <button
              className="w-10 h-10 rounded-full bg-zinc-100 hover:bg-zinc-200 text-zinc-600 text-lg font-bold shadow"
              onClick={() => props?.setAmount(props?.amount < props?.maxAmount ? props?.amount + 1 : props?.maxAmount)}
            >
              +
            </button>
          </div>

          <p className="text-sm text-zinc-500">
            Total available:{" "}
            <span className="font-semibold text-zinc-800">{props?.maxAmount}</span> entries
          </p>
        </div>

        <div className="flex w-full">
          <div className="lg:flex gap-2">
            <Button 
              color="primary"
              className="text-white w-full lg:w-[272px] rounded-[10px]"
              onClick={props?.onButtonExportClick}
            >
              EXPORT DATA
            </Button> 
            <Button 
              className="text-white w-full lg:w-[272px] rounded-[10px] bg-[#A8A8A8] hover:bg-[#8C8B8B]"
              onClick={props?.onHide}
            >
              CANCEL
            </Button> 
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}